import { documentsConstants } from '../../constants/documents.constants';
import  moment  from 'moment';

const defaultDateRange = [
  moment().subtract(3, 'month').add(1, 'days'),
  moment(),
];

const valueFilter = {
  dateRange: defaultDateRange,
	selectedDateRange: undefined,
	dateRangeField: 'create_time',
	valueDistrict: undefined,
	valueCompany: [],
  valueServiceCompany: undefined,
	valueWorker: [],
	valueExecuter: null,
	responsibleWorker: null,
	valueCreator: [],
	valueStatus: [],
	valueType: [],
  valueSubType: [],
	valueSubservice: undefined,
	valueService: undefined,
	valueAddrStreet: undefined,
	valueAddrBuilding: undefined,
	valueAddrFlat: undefined,
	valuePhone: undefined,
	valueRating: undefined,
	warranty: false,
	notWarranty: false,
	possWarranty: false,
	retry: false,
	chargeable: false,
	immediate: false,
	badWork: false,
  viewOtherDocs: false,
}

const defaultState = {
	reportVisible: false,
	filterVisible: false,
	filterNewVisible: false,
	filterCompany: [],
	filterDistrict: [],
	filterWorker: [],
	filterExecuter: [],
	filterStatus: [],
	filterType: [],
	documents: [],
	listSubservice: [],
	listAddrBuilding: [],
	listAddrFlat: [],
	reports: [],
	report: undefined,
	goResort: false,
	search: undefined,
  expiredMode: false,
  expiredModeQuery: '',
	relatedDocsModalVisible: null,
	...valueFilter,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case documentsConstants.SET_DOCUMENT_SEARCH: {
			return {
				...state,
				dataFetching: false,
				search: action.payload,
			}
		}
		case documentsConstants.POST_ERROR: {
			return {
				...state,
				dataFetching: false,
				apiResponseError: 'Ошибка при добавлении документа',
				apiResponseText: action.payload,
			}
		}
		case documentsConstants.RESET_FILTER: {
			return {
				...state,
				...valueFilter
			}
		}
		case documentsConstants.UNSET_RESORT: {
			return {
				...state,
				goResort: false
			}
		}
		case documentsConstants.SET_VISIBLE_RELATED_DOCS_MODAL: {
			return {
				...state,
				relatedDocsModalVisible: action.payload,
			}
		}
		case documentsConstants.FETCH_SUBSERVICE + '_FULFILLED': {
			return {
				...state,
				listSubservice: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.SET_ADDR_BUILDING_VALUE: {
			return {
				...state,
				valueAddrBuilding: action.payload
			}
		}
		case documentsConstants.SET_ADDR_FLAT_VALUE: {
			return {
				...state,
				valueAddrFlat: action.payload
			}
		}
		case documentsConstants.SET_PHONE_VALUE: {
			return {
				...state,
				valuePhone: action.payload
			}
		}
		case documentsConstants.SET_RATING_VALUE: {
			return {
				...state,
				valueRating: action.payload
			}
		}
		case documentsConstants.APPLY_ADDR_STREET: {
			return {
				...state,
				valueAddrStreet: action.payload
			}
		}
		case documentsConstants.FETCH_ADDR_BUILDING + '_FULFILLED': {
			return {
				...state,
				listAddrBuilding: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.FETCH_ADDR_FLAT + '_FULFILLED': {
			return {
				...state,
				listAddrFlat: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.SET_SUBSERVICE_VALUE: {
			return {
				...state,
				valueSubservice: action.payload
			}
		}
		case documentsConstants.SET_REPORT: {
			return {
				...state,
				report: action.payload
			}
		}
		case documentsConstants.MARK_REQUEST_VIEWED + '_FULFILLED': 
		case documentsConstants.SET_REQUEST_EXECUTE_TIME + '_FULFILLED': 
		case documentsConstants.SET_REQUEST_EXECUTER + '_FULFILLED': 
		case documentsConstants.SET_REQUEST_MASTER + '_FULFILLED': 
		case documentsConstants.SET_REQUEST_SERVICE + '_FULFILLED': 
		case documentsConstants.SET_REQUEST_RATING + '_FULFILLED': 
		case documentsConstants.SET_REQUEST_STATUS + '_FULFILLED': 
		case documentsConstants.FETCH_DOCUMENTS + '_FULFILLED': {
			return {
				...state,
				documents: action.payload ? (action.payload.data.data || action.payload.data) : [],
				goResort: true,
				dataFetching: false,
				apiResponseError: null
			}
		}
		case documentsConstants.MARK_REQUEST_VIEWED + '_PENDING': 
		case documentsConstants.SET_REQUEST_EXECUTE_TIME + '_PENDING': 
		case documentsConstants.SET_REQUEST_EXECUTER + '_PENDING': 
		case documentsConstants.SET_REQUEST_MASTER + '_PENDING': 
		case documentsConstants.SET_REQUEST_SERVICE + '_PENDING': 
		case documentsConstants.SET_REQUEST_RATING + '_PENDING': 
		case documentsConstants.SET_REQUEST_STATUS + '_PENDING': 
			case documentsConstants.FETCH_DOCUMENTS + '_PENDING': {
			return {
				...state,
				dataFetching: true
			}
		}
		case documentsConstants.CLOSE_FILTER: {
			return {
				...state,
				filterVisible: action.payload
			}
		}
		case documentsConstants.SET_FILTER_NEW_VISIBLE: {
			return {
				...state,
				filterNewVisible: action.payload
			}
		}
		case documentsConstants.CLOSE_REPORT: {
			return {
				...state,
				reportVisible: action.payload
			}
		}
		case documentsConstants.SET_DATE_RANGE: {
			return {
				...state,
				dateRange: action.payload
			}
		}
		case documentsConstants.SELECT_DATE_RANGE: {
			return {
				...state,
				selectedDateRange: action.payload,
				dateRange: action?.payload?.range || defaultDateRange,
			}
		}
		case documentsConstants.SET_DATE_RANGE_FIELD: {
			return {
				...state,
				dateRangeField: action.payload
			}
		}
		case documentsConstants.APPLY_WARRANTY: {
			return {
				...state,
				warranty: action.payload,
				notWarranty: false
			}
		}
		case documentsConstants.APPLY_NOT_WARRANTY: {
			return {
				...state,
				warranty: false,
				notWarranty: action.payload
			}
		}
		case documentsConstants.APPLY_POSS_WARRANTY: {
			return {
				...state,
				possWarranty: action.payload
			}
		}
		case documentsConstants.APPLY_RETRY: {
			return {
				...state,
				retry: action.payload
			}
		}
		case documentsConstants.APPLY_CHARGEABLE: {
			return {
				...state,
				chargeable: action.payload
			}
		}
		case documentsConstants.APPLY_IMMEDIATE: {
			return {
				...state,
				immediate: action.payload
			}
		}
		case documentsConstants.APPLY_BADWORK: {
			return {
				...state,
				badWork: action.payload
			}
		}
		case documentsConstants.APPLY_COMPANY: {
			return {
				...state,
				valueCompany: action.payload
			}
		}
		case documentsConstants.APPLY_DISTRICT: {
			return {
				...state,
				valueDistrict: action.payload
			}
		}
		case documentsConstants.SET_REPORTS + '_FULFILLED': {
			return {
				...state,
				reports: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.SET_FILTER_COMPANY + '_FULFILLED': {
			return {
				...state,
				filterCompany: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.SET_FILTER_DISTRICT + '_FULFILLED': {
			return {
				...state,
				filterDistrict: action.payload.data.data || action.payload.data
			}
		}
    case documentsConstants.APPLY_SERVICE_COMPANY: {
      return {
        ...state,
        valueServiceCompany: action.payload,
      };
    }
		case documentsConstants.APPLY_WORKER: {
			return {
				...state,
				valueWorker: action.payload
			}
		}
		case documentsConstants.APPLY_EXECUTER: {
			return {
				...state,
				valueExecuter: action.payload
			}
		}
		case documentsConstants.APPLY_CREATOR: {
			return {
				...state,
				valueCreator: action.payload
			}
		}
		case documentsConstants.APPLY_RESPONSIBLE_WORKER: {
			return {
				...state,
				responsibleWorker: action.payload
			}
		}
		case documentsConstants.APPLY_SERVICE: {
			return {
				...state,
				valueService: action.payload
			}
		}
		case documentsConstants.SET_FILTER_WORKER + '_FULFILLED': {
			return {
				...state,
				filterWorker: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.SET_FILTER_EXECUTER + '_FULFILLED': {
			return {
				...state,
				filterExecuter: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.APPLY_STATUS: {
			return {
				...state,
				valueStatus: action.payload
			}
		}
		case documentsConstants.APPLY_TYPE: {
			return {
				...state,
				valueType: action.payload
			}
    }
    case documentsConstants.APPLY_SUBTYPE: {
      return {
        ...state,
        valueSubType: action.payload,
      };
    }
    case documentsConstants.SET_VIEW_OTHER_DOCS: {
      return {
        ...state,
        viewOtherDocs: action.payload,
      };
    }
    case documentsConstants.SET_EXPIRED_MODE: {
      return {
        ...state,
        expiredMode: action.payload,
      };
    }
    case documentsConstants.SET_EXPIRED_MODE_QUERY: {
      return {
        ...state,
        expiredModeQuery: action.payload,
      };
    }

		case documentsConstants.SET_DOCUMENT_FILTER_VALUES: {
			const {
				dateRange,
					dateRangeField,
					valueType,
					valueStatus,
					valueExecuter,
					responsibleWorker,
					valueCreator,
					valueCompany,
					valueAddrStreet,
					valueAddrBuilding,
					valueAddrFlat,
					valueServiceCompany,
			} = action.payload
			return {
				...state,
				dateRange,
				dateRangeField,
				valueType,
				valueStatus,
				valueExecuter,
				responsibleWorker,
				valueCreator,
				valueCompany,
				valueAddrStreet,
				valueAddrBuilding,
				valueAddrFlat,
				valueServiceCompany,
			}
		}
		case documentsConstants.SET_FILTER_STATUS + '_FULFILLED': {
			return {
				...state,
				filterStatus: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.SET_FILTER_TYPE + '_FULFILLED': {
			return {
				...state,
				filterType: action.payload.data.data || action.payload.data
			}
		}
		case documentsConstants.SET_FILTER_STATUS +'_REJECTED': 
		case documentsConstants.SET_FILTER_TYPE +'_REJECTED': 
		case documentsConstants.FETCH_DOCUMENTS +'_REJECTED': 


		case documentsConstants.SET_REPORTS +'_REJECTED': 
		case documentsConstants.SET_REQUEST_EXECUTE_TIME + '_REJECTED': 
		case documentsConstants.SET_REQUEST_EXECUTER + '_REJECTED': 
		case documentsConstants.SET_REQUEST_MASTER + '_REJECTED': 
		case documentsConstants.SET_REQUEST_SERVICE + '_REJECTED': 
		case documentsConstants.SET_REQUEST_RATING +'_REJECTED': 
		case documentsConstants.SET_REQUEST_STATUS +'_REJECTED': 		
		case documentsConstants.SET_FILTER_COMPANY +'_REJECTED': 
		case documentsConstants.SET_FILTER_WORKER +'_REJECTED': 
		case documentsConstants.SET_FILTER_EXECUTER +'_REJECTED': 
		case documentsConstants.SET_FILTER_DISTRICT +'_REJECTED': 
		case documentsConstants.FETCH_ADDR_BUILDING +'_REJECTED': 
		case documentsConstants.FETCH_ADDR_FLAT +'_REJECTED': 
		case documentsConstants.FETCH_SUBSERVICE +'_REJECTED': {			
			return {
				...state,
				dataFetching: false,
				apiResponseError: (action.payload.response && action.payload.response.status) || action.payload,
				apiResponseText: action.payload.response && action.payload.response.statusText
			}
		}
		default:
			return state;
	}
}